"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/web.timers.js");

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _task = require("sk-web-framework/api/task");

var _vuex = require("vuex");

var _default = {
  computed: (0, _objectSpread2["default"])({}, (0, _vuex.mapGetters)(['taskIds'])),
  watch: {
    taskIds: function taskIds(newVal, oldVal) {
      // 有新的任务
      var taskId = newVal[newVal.length - 1];

      if (taskId && !this[taskId + 'TimerId']) {
        this.trackTask(taskId);
      }
    }
  },
  methods: {
    trackTask: function trackTask(taskId) {
      var _this = this;

      (0, _task.getTask)({
        msgRelationId: taskId,
        msgType: 'BATCH_MSG'
      }).then(function (result) {
        _this.handleTaskResult(result, taskId);
      })["catch"](function (e) {
        _this.handleGetTaskResultError(taskId);

        if (e) {
          throw e;
        }
      });
    },
    handleTaskResult: function handleTaskResult(result, taskId) {
      var _this2 = this;

      var task = result;

      if (task) {
        if (task.msgState !== 'PROCESSING') {
          this.$store.dispatch('RefreshView', {
            data: result,
            taskId: taskId
          });
        }

        var index = (0, _findIndex["default"])(this.taskIds, taskId);
        setTimeout(function () {
          _this2.$store.dispatch('OpenNotification', {
            message: task.describe,
            i18n: false,
            duration: task.msgState === 'PROCESSING' ? 0 : 5000,
            // 进行中，不让自动关闭
            type: task.msgState,
            option: {
              id: taskId,
              restart: task.msgState === 'PROCESSING'
            }
          });
        }, index * 100);
        var taskTimerId = this[taskId + 'TimerId'];

        if (task.msgState !== 'PROCESSING') {
          this.$store.dispatch('RemoveTaskId', taskId);
          this.$store.dispatch('PublishAsynchronousTask', {
            data: result,
            taskId: taskId,
            status: task.msgState
          });
          this.clearTrackTaskHandle(taskTimerId);
        } else {
          if (taskTimerId) {
            this.clearTrackTaskHandle(taskTimerId);
            this.startTrackTask(taskId);
          } else {
            this.startTrackTask(taskId);
          }
        }
      }
    },
    handleGetTaskResultError: function handleGetTaskResultError(taskId) {
      var result = {
        id: taskId,
        describe: this.$t('getTaskError'),
        msgState: 'ERROR'
      };
      this.handleTaskResult(result, taskId);
    },
    startTrackTask: function startTrackTask(taskId) {
      var _this3 = this;

      this[taskId + 'TimerId'] = window.setTimeout(function () {
        _this3.trackTask(taskId);
      }, 1000);
    },
    clearTrackTaskHandle: function clearTrackTaskHandle(taskTimerId) {
      window.clearTimeout(taskTimerId);
      this[taskTimerId] = null;
    }
  }
};
exports["default"] = _default;